import { Environment } from '@kameleoon/react-sdk'
import { ENVIRONMENTS, EnvKey } from '../constants/environments'

type FeatureFlag = {
  key: string;
  defaultVariation: string;
  experimentId: string;
}

export const qualifyFormReviewsFeatureFlagConfig: FeatureFlag = {
  key: `sleep_-_google_reviews_qualify_form`,
  defaultVariation: `off`,
  experimentId: process.env.REACT_APP_KAMELEOON_QUALIFY_FORM_REVIEWS_EXPERIMENT_ID || ``
}

export function getEnvironment(): Environment {
  const envValue = process.env.REACT_APP_ENVIRONMENT || ``

  const environmentMap: Record<EnvKey, Environment> = {
    [ENVIRONMENTS.PRODUCTION]: Environment.Production,
    [ENVIRONMENTS.STAGE]: Environment.Staging
  }

  if ( envValue in environmentMap ) {
    return environmentMap[envValue as EnvKey]
  }

  return Environment.Development
}